import { ReactNode } from "react";

export function nullishResolver<T = unknown>(value: T | null | undefined, defaultValue: T): T {
	return value ?? defaultValue;
}

export function and(...conditions: boolean[]) {
	return conditions.every(Boolean);
}

export function or(...conditions: boolean[]) {
	return conditions.findIndex(Boolean) !== -1;
}

export function ternaryResolver<T = unknown>(condition: boolean, valueIfTrue: T, valueIfFalse: T): T {
	return condition ? valueIfTrue : valueIfFalse;
}

export function renderIf(condition: boolean, render: ReactNode) {
	return condition ? render : null;
}
